// extracted by mini-css-extract-plugin
export default {"inputCustom":"LeftFilter_inputCustom__tr+2-"};